import SelectLodgingModal from './select-lodging-modal.view';

export default SelectLodgingModal;
